import React, { useEffect, useState } from "react";
import { getMerchant } from '../../helpers/ReduxHelpers';
import { apiConstants, getGeneric, postGeneric } from '../../common/constants';
import { useForm } from "react-hook-form";
import { Box, Button, FormControlLabel, Grid, Switch, Tooltip, Typography } from "@mui/material";
import { FormProvider, RHFDateTimeField, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup'
import Loader from "../../common/Loader"
import { useSnackbar } from "notistack";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import ConfirmDialog from "../../common/ConfirmDialog";
import { parseTime2 } from "../../helpers/UtilityHelper";
import { primaryBtnSx, filterBarSx } from '../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, SUBTLE } from '../../styles/foundation/colors';
import { primaryTextSx, cellStackSx } from '../orders/list2/cellStyles';

const NPREmailConfig = () => {
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''


    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [nprConfig, setNPRConfig] = useState();
    const [isNPREnabled, setNPREnabled] = useState(false);
    const [reload, setReload] = useState(0);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteData, setDeleteData] = useState();
    const [switchConfirm, setSwitchConfirm] = useState(false);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [timeVal, setTimeVal] = useState('');

    const columns = [
        {
            field: 'emails',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Emails',
            flex: 1.2,
            minWidth: 250,
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}><Typography sx={primaryTextSx}>{row?.email}</Typography></Box>
                )
            },
        },
        {
            field: 'action',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Action',
            flex: 0.5,
            minWidth: 120,
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => handleCancelOrder(row)}
                        disabled={!isNPREnabled}
                        color="error"
                        variant="outlined"
                        size="small"
                    >
                        Delete
                    </Button>

                );
            },
        },
    ];

    const emailListRegExp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}\s*,\s*)*[\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}$/
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                email: Yup.string()
                    .matches(emailListRegExp, { message: 'Invalid email format', excludeEmptyString: true })
                    .required("Email is required!"),
            })
        ),
        defaultValues: {
            email: '',
        }
    })
    const { handleSubmit: handleSubmitForm, reset } = methods

    const postNPRConfigUpdate = (payload) => {
        postGeneric(`${apiConstants.UPDATE_NDR_EMAIL_CONFIG}`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar('Some error occurred', { variant: 'error' })
                setLoading(false)
            })
    }
    const postNPRConfigAdd = (payload) => {
        postGeneric(`${apiConstants.ADD_NDR_EMAIL_CONFIG}`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar('Some error occurred', { variant: 'error' })
                setLoading(false)
            })
    }

    const onSubmit = (data) => {
        setLoading(true);
        const emailsArray = data.email.split(',').map(email => email.trim());
        const existingEmails = nprConfig?.last30DaysNprReceivedByEmails ?? [];

        const payload = {
            merchantOId: merchantId,
            last30DaysNprReceivedByEmails: [...existingEmails, ...emailsArray],
            last30DaysNprReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNprEnabled: true,
            last30DaysNprEmailCronTime: timeVal
        }
        // if (nprConfig?.last30DaysNprReceivedByEmails || nprConfig?.last30DaysNprReceivedByEmails.length === 0 || nprConfig?.last30DaysNprReceivedByEmails === null) {
        if (nprConfig) {
            postNPRConfigUpdate(payload)
        } else {
            postNPRConfigAdd(payload)
        }
    }
    const handleCancelOrder = (data) => {
        setDeleteData(data)
        setDeleteConfirm(true)
    }
    const handleDelete = () => {
        const index = nprConfig?.last30DaysNprReceivedByEmails?.indexOf(deleteData.email);
        if (index !== -1) {
            nprConfig?.last30DaysNprReceivedByEmails.splice(index, 1);
        }
        const payload = {
            merchantOId: merchantId,
            last30DaysNprReceivedByEmails: [...nprConfig?.last30DaysNprReceivedByEmails],
            last30DaysNprReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNprEnabled: true,
            last30DaysNprEmailCronTime: timeVal
        }
        postNPRConfigUpdate(payload)
    }
    useEffect(() => {
        setLoading(true)
        getGeneric(`${apiConstants.GET_NDR_EMAIL_CONFIG}?merchantOId=${merchantId}`).then((res) => {
            setNPRConfig(res.data);
            setTimeVal(res.data?.last30DaysNprEmailCronTime)
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }, [merchantId, reload])
    const toggleEmail = () => {
        let payload = {
            merchantOId: merchantId,
            last30DaysNprReceivedByEmails: [...nprConfig?.last30DaysNprReceivedByEmails],
            last30DaysNprReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNprEnabled: isNPREnabled ? false : true,
            last30DaysNprEmailCronTime: timeVal
        }
        postNPRConfigUpdate(payload)
    }

    useEffect(() => {
        setNPREnabled(nprConfig?.isLast30DaysNprEnabled)
    }, [nprConfig])

    const handleSwitchConfirmation = (e) => {
        setSwitchConfirm(true);
    };
    const handleSwitchAction = () => {
        toggleEmail()
    };

    const formatTime = (time) => {
        if (time instanceof Date) {
            return time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
        }
        return time;
    }

    return (
        <>
            {(isLoading) && <Loader />}
            <ConfirmDialog
                title=''
                open={deleteConfirm}
                setOpen={setDeleteConfirm}
                onConfirm={() => handleDelete()}>
                Are you sure you want to delete this email ?
            </ConfirmDialog>
            <ConfirmDialog
                title=''
                open={switchConfirm}
                setOpen={setSwitchConfirm}
                onConfirm={() => handleSwitchAction()}>
                Are you sure you want to change the email configuration?
            </ConfirmDialog>
            <Box sx={filterBarSx}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.semibold, color: NAVY }}>NPR Email Configuration</Typography>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE, mt: 0.5 }}>Configure NPR email notifications and schedules</Typography>
                    </Box>
                    <Tooltip title={isNPREnabled ? "Disable NPR Emails" : "Enable NPR Emails"}>
                        <FormControlLabel
                            control={<Switch checked={isNPREnabled} onChange={(e) => handleSwitchConfirmation(e)} disabled={!nprConfig?.last30DaysNprReceivedByEmails?.length > 0} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' } }} />}
                            label={<Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: isNPREnabled ? '#4caf50' : SUBTLE }}>{isNPREnabled ? 'Enabled' : 'Disabled'}</Typography>}
                            labelPlacement="start"
                        />
                    </Tooltip>
                </Box>
                <FormProvider methods={methods} onSubmit={handleSubmitForm(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <RHFTextField name="email" label="Add Emails *" size="small" />
                        </Grid>
                        <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <LoadingButton loading={isLoading} type="submit" variant="contained" size="small" sx={primaryBtnSx}>Add</LoadingButton>
                        </Grid>
                    </Grid>
                </FormProvider>
                <EmailTime postNPRConfigUpdate={postNPRConfigUpdate}
                    postNPRConfigAdd={postNPRConfigAdd}
                    merchantId={merchantId} nprConfig={nprConfig}
                    setLoading={setLoading} isNPREnabled={isNPREnabled}
                    setReload={setReload}
                    setTimeVal={setTimeVal}
                />
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE }} component="span">Current Email Time: </Typography>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.semibold, color: isNPREnabled ? NAVY : SUBTLE }} component="span">
                        {isNPREnabled ? (timeVal ? formatTime(timeVal) : 'Not Updated') : "Emails Disabled"}
                    </Typography>
                </Grid>
            </Box>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <ProzoDataGrid
                    columns={columns}
                    autoHeight={true}
                    rows={nprConfig?.last30DaysNprReceivedByEmails?.length > 0 ? nprConfig?.last30DaysNprReceivedByEmails?.map((email, index) => ({ id: index, email })) : []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    pagination={true}
                    paginationMode='client'
                    rowCount={nprConfig?.last30DaysNprReceivedByEmails?.length || 0}
                    getRowId={(row) => row.id}
                />
            </Grid>
        </>
    );
};

export default NPREmailConfig;



const EmailTime = ({ merchantId, nprConfig, setLoading, setReload, setTimeVal, isNPREnabled }) => {
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                time: Yup.date()
                    .required('Time is required!')
                    .typeError('Time is required!'),
            })
        ),
        defaultValues: {
            time: ''
        }
    })
    const { handleSubmit, reset } = methods

    const onSubmit = (data) => {
        setLoading(true);
        let payload = {
            merchantOId: merchantId,
            last30DaysNprReceivedByEmails: [...nprConfig?.last30DaysNprReceivedByEmails],
            last30DaysNprReceivedByCCEmails: ["ProshipTechTeam@prozo.com"],
            isLast30DaysNprEnabled: true,
            last30DaysNprEmailCronTime: data.time ? parseTime2(data.time) : ''
        }
        postGeneric(`${apiConstants.UPDATE_NDR_EMAIL_CONFIG}`, payload).then(response => {
            setTimeVal(data.time);
            setReload(reload => reload + 1);
            reset()
        })
            .catch((err) => {
                console.error(err)
                setLoading(false)
            })

    }
    return (
        <>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'row' }}>
                        <RHFDateTimeField mode="time"
                            name="time"
                            label="Update Email Time "
                            size='small'
                            disabled={!nprConfig?.last30DaysNprReceivedByEmails?.length > 0 || !isNPREnabled}
                        />
                    </Grid>
                    <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button size="small"
                            variant="contained"
                            disabled={!nprConfig?.last30DaysNprReceivedByEmails?.length > 0 || !isNPREnabled}
                            type="submit"
                            sx={primaryBtnSx}
                        >
                            Update
                        </Button>
                    </Grid>
                </Grid>
            </FormProvider>
        </>
    )
}